export default __webpack_public_path__ + "static/media/delete3.2ebfb3be.svg";